import { render, staticRenderFns } from "./TransactionsOfBill.vue?vue&type=template&id=bfe9fb82"
import script from "./TransactionsOfBill.vue?vue&type=script&lang=js"
export * from "./TransactionsOfBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports